import {
  BOT_DETERRENCE_ENABLED,
  MIN_FORM_FILL_MS,
  FAKE_FAILURE_DELAY_MIN_MS,
  FAKE_FAILURE_DELAY_MAX_MS,
} from '../../constants/botDeterrence';

/**
 * Returns why a submission looks bot-like, or null when it looks human.
 * 'honeypot' — the hidden field was filled (real users can't reach it).
 * 'timing' — submitted faster than a human could type a password.
 *
 * The timing check is skipped when the password was autofilled or pasted —
 * that's legitimate password-manager use and completes near-instantly, so it
 * would otherwise be indistinguishable from a bot filling the form.
 */
export const getBotRejectionReason = (
  values,
  formIssuedAt,
  wasAutofilledOrPasted,
) => {
  if (!BOT_DETERRENCE_ENABLED) {
    return null;
  }
  if (values?.contact_preference) {
    return 'honeypot';
  }
  if (
    !wasAutofilledOrPasted &&
    performance.now() - formIssuedAt < MIN_FORM_FILL_MS
  ) {
    return 'timing';
  }
  return null;
};

/** Random delay so a local rejection is indistinguishable from an API round trip. */
export const getFakeFailureDelay = () =>
  FAKE_FAILURE_DELAY_MIN_MS +
  Math.random() * (FAKE_FAILURE_DELAY_MAX_MS - FAKE_FAILURE_DELAY_MIN_MS);
